var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitemapSolidB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86513 1.94444C5.86513 1.30034 6.3877 0.777771 7.03179 0.777771H8.58735C9.23145 0.777771 9.75401 1.30034 9.75401 1.94444V3.49999C9.75401 4.14409 9.23145 4.66666 8.58735 4.66666H8.3929V5.63888H12.0873C12.8384 5.63888 13.4485 6.24895 13.4485 6.99999V7.77777H13.6429C14.287 7.77777 14.8096 8.30034 14.8096 8.94444V10.5C14.8096 11.1441 14.287 11.6667 13.6429 11.6667H12.0873C11.4433 11.6667 10.9207 11.1441 10.9207 10.5V8.94444C10.9207 8.30034 11.4433 7.77777 12.0873 7.77777H12.2818V6.99999C12.2818 6.89305 12.1943 6.80555 12.0873 6.80555H8.3929V7.77777H8.58735C9.23145 7.77777 9.75401 8.30034 9.75401 8.94444V10.5C9.75401 11.1441 9.23145 11.6667 8.58735 11.6667H7.03179C6.3877 11.6667 5.86513 11.1441 5.86513 10.5V8.94444C5.86513 8.30034 6.3877 7.77777 7.03179 7.77777H7.22624V6.80555H3.53179C3.42485 6.80555 3.33735 6.89305 3.33735 6.99999V7.77777H3.53179C4.17589 7.77777 4.69846 8.30034 4.69846 8.94444V10.5C4.69846 11.1441 4.17589 11.6667 3.53179 11.6667H1.97624C1.33214 11.6667 0.80957 11.1441 0.80957 10.5V8.94444C0.80957 8.30034 1.33214 7.77777 1.97624 7.77777H2.17068V6.99999C2.17068 6.24895 2.78075 5.63888 3.53179 5.63888H7.22624V4.66666H7.03179C6.3877 4.66666 5.86513 4.14409 5.86513 3.49999V1.94444Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12.4444,
    fill: "white",
    transform: "translate(0.80957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemapSolidB);
export default __webpack_public_path__ + "static/media/sitemap-solid-b.317ab51262e153ea6a48ef1d6e0c588f.svg";
export { ForwardRef as ReactComponent };